import axios from 'axios';

const apiToken = process.env.VUE_APP_API_TOKEN;

function rewriteLocalHostIfNeeded(apiLink) {
  if (!apiLink) {
    return apiLink;
  }

  try {
    const parsed = new URL(apiLink);
    const browserHost = window.location.hostname;
    const isLoopbackTarget = parsed.hostname === '127.0.0.1' || parsed.hostname === 'localhost';

    if (isLoopbackTarget && browserHost) {
      parsed.hostname = browserHost;
      return parsed.toString();
    }
  } catch (error) {
    return apiLink;
  }

  return apiLink;
}

function normalizeBaseUrl(apiLink) {
  const rawBaseUrl = apiLink
    || localStorage.getItem('api_link')
    || process.env.VUE_APP_API_BASE_URL
    || '';

  return rewriteLocalHostIfNeeded(rawBaseUrl).replace(/\/+$/, '');
}

export function createApiClient(apiLink) {
  const baseURL = normalizeBaseUrl(apiLink);
  const headers = {};

  if (apiToken) {
    headers['x-api-key'] = apiToken;
  }

  return axios.create({
    baseURL,
    withCredentials: true,
    headers,
  });
}
